import { render, staticRenderFns } from "./JImportModal.vue?vue&type=template&id=82ce9c1c&scoped=true"
import script from "./JImportModal.vue?vue&type=script&lang=js"
export * from "./JImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ce9c1c",
  null
  
)

export default component.exports